import { CandidateModel } from '../model/candidate';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

import 'rxjs/add/operator/map';

import { Observable } from 'rxjs/Observable';
import { _throw as throwError } from 'rxjs/observable/throw';
import { catchError, retry } from 'rxjs/operators';

import 'rxjs/add/operator/catch';


const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    'Pragma': 'no-cache'
    //'Authorization': 'Bearer XXXXXXXX'
  })
};

export interface ISessionStoreReturnModel {
  status: number;
  success: boolean;
  value: string;
}


@Injectable()
export class SessionService {

  constructor(private http: HttpClient) { }

  abandonSessionState(): Observable<any> {

    return this.http
      .get<ISessionStoreReturnModel>('sessionStore/sessionAbandon',httpOptions )
      .map(response => {
        response = response;
        return response;
      })
      .catch(this.handleError);
  }


  getSessionValue(keyName: string): Observable<any> {

    return this.http
      .get<ISessionStoreReturnModel>(`sessionstore/sessionPull?keyName=${keyName}`,httpOptions)
      .map(response => {
        response = response;
        return response;
      })
      .catch(this.handleError);
  }

  putSessionValue(keyName: string, value: string) {

    return this.http.post<ISessionStoreReturnModel>('sessionstore/sessionPush', { keyName, value }, httpOptions)
      .map(response => {
        response = response;
        return response;
      })
      .catch(this.handleError)
      .subscribe(
        (data) => console.log(data)
      );
  }

  clearSessionValue(keyName: string) {

    return this.http.post<ISessionStoreReturnModel>('sessionStore/sessionClear', { keyName }, httpOptions)
      .map(response => {
        response = response;
        return response;
      })
      .catch(this.handleError)
      .subscribe(
        (data) => console.log(data)
      );
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
    }
    // return an observable with a user-facing error message
    return throwError(
      'Something bad happened; please try again later.');
  };

}



// WEBPACK FOOTER //
// ./src/app/service/session.service.ts